const dynamicFormState = {
  title: 'Stay tuned',
  description: 'Sign up to get the latest news, updates and special offers',
  background: {
    type: 'image',
    imageURL: '',
    color: '',
  },
  actionData: {
    actionType: 'dynamicForm',
    actionTemplate: 'default',
    fields: [
      {
        title: 'Email',
        hint: 'Enter your email',
        type: 'email',
        optional: false,
        maxLength: 50,
        maxLine: 10,
      },
    ],
    submitButtonText: '',
    gdprConfig: {
      isActive: false,
      privacyPolicyURL: '',
      termsOfServiceURL: '',
      description: '',
      provider: '',
      organiser: '',
    },
  },
};

export default dynamicFormState;
